export default __webpack_public_path__ + "static/media/databaseScaling.0b9f8243.md";